module.exports = __webpack_public_path__ + "img/cooperative0_logo0.9f16f258.jpg";